import { CustomerOrderOfferLineView } from "src/api/generated/erp/db/types/tables/customerOrderOfferLineView.ts";

export type SubConfigurationImportSourceOfferLine = Pick<
	CustomerOrderOfferLineView,
	| "customerOrderOfferLineId"
	| "lineNumber"
	| "salesPartNo"
	| "salesPartType"
	| "configurationOrPartDescription"
	| "partConfigurationId"
>;

export async function fetchSourceOfferLinesRecursively(
	fetchLines: (parentLineId: number | null) => Promise<SubConfigurationImportSourceOfferLine[]>,
	parentLineId: number | null = null,
): Promise<SubConfigurationImportSourceOfferLine[]> {
	const lines = await fetchLines(parentLineId);
	const descendantsByLine = await Promise.all(
		lines.map((line) =>
			line.salesPartType === "PACKAGE_" ?
				fetchSourceOfferLinesRecursively(fetchLines, line.customerOrderOfferLineId)
			:	[],
		),
	);

	return lines.flatMap((line, index) => [line, ...descendantsByLine[index]!]);
}
